module.exports = __webpack_public_path__ + "img/hy.ee893482.png";